/** @format */

import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

interface SortingArrowsProps {
  sortId?: string;
  sort: Record<string, 'asc' | 'desc'>;
}

const StyledSortingArrows = styled.div``;

function SortingArrows(props: SortingArrowsProps) {
  if (!props.sort) {
    return null;
  }
  if (!props.sortId || !(props.sortId in props.sort)) {
    return (
      <FontAwesomeIcon
        css={css`
          margin-right: 18px;
          color: #969696;
          //color: var(--grey-100);
        `}
        icon={['far', 'sort']}
      />
    );
  }
  return props.sort[props.sortId] === 'desc' ? (
    <FontAwesomeIcon
      css={css`
        margin-right: 18px;
      `}
      icon={['fad', 'sort-down']}
    />
  ) : (
    <FontAwesomeIcon
      css={css`
        margin-right: 18px;
      `}
      icon={['fad', 'sort-up']}
    />
  );
}

export default SortingArrows;
